document.addEventListener('DOMContentLoaded', function () {


  /*sob medida*/
  function mostrarBlocosSobMedida() {
    document.querySelectorAll('.product__block--lines + .product__block.product__text').forEach(function (el) {
      el.style.display = 'block';
    });

    document.querySelectorAll('.product__block.product__block--lines.select__fieldset').forEach(function (el) {
      el.style.display = 'block';
    });
  }

  function escondeBlocosSobMedida() {
    document.querySelectorAll('.product__block--lines + .product__block.product__text').forEach(function (el) {
      el.style.display = 'none';
    });

    document.querySelectorAll('.product__block.product__block--lines.select__fieldset').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  document.querySelectorAll('.radio__button').forEach(function (button) {
    button.addEventListener('click', function () {
      var span = button.querySelector('span');
      if (span && span.textContent.trim().toUpperCase() === 'SOB MEDIDA') {
        mostrarBlocosSobMedida();
      } else {
        escondeBlocosSobMedida();
      }
    });
  });

  var checkedInput = document.querySelector('.radio__button input[type="radio"]:checked');
  if (checkedInput) {
    var parentButton = checkedInput.closest('.radio__button');
    if (parentButton) {
      var span = parentButton.querySelector('span');
      if (span && span.textContent.trim().toUpperCase() === 'SOB MEDIDA') {
        mostrarBlocosSobMedida();
      } else {
        escondeBlocosSobMedida();
      }
    }
  }
  /*FIM sob medida*/

});
